import { connect } from 'react-redux';
import AuditSearchComponent from 'src/components/custom/AuditSearch';
import { IStoreState } from 'src/entity/StateEntity';

const mapStateToProps = ({ userState: { isDomestic } }: IStoreState) => ({
  isDomestic,
});

export default connect(mapStateToProps)(AuditSearchComponent);



// WEBPACK FOOTER //
// ./src/containers/AuditSearch.ts